import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { Box, Stack, Typography, useTheme } from "@mui/material";

import RequestDemo from "../components/popups/requestDemo";
import StyledButton from "../components/styled/styledButton";

import { isMobileDevice } from "../utils/deviceUtils";
import StyledHeader from "../components/styled/styledHeader";
import StyledBox from "../components/styled/styledBox";

const iconTexts = [
  "4–14% of additional savings",
  "Save time using active contracts and onboarded suppliers",
  "Flag high-risk suppliers",
  "Efficiently drive ESG metrics",
];

export default function Procurement() {
  const theme = useTheme();

  const [isOpenRequestDemo, setIsOpenRequestDemo] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setIsMobile(isMobileDevice(userAgent));
  }, []);

  return (
    <>
      <Helmet>
        <title>Partner Element - Procurement</title>
        <link rel="icon" href="/favicon.ico" sizes="any" />
      </Helmet>

      <Box>
        <StyledBox
          sx={{
            "@media (max-width: 1200px)": {
              paddingLeft: "3%",
              paddingRight: "3%",
            },
          }}
        >
          <Box
            sx={{
              color: theme.palette.text.neutral,
              height: "590px",
              fontFamily: "Coil",
              fontSize: "80px",
              fontWeight: "400",
              lineHeight: "80px",
              letterSpacing: "-2.4px",
              marginBottom: "64px",
              marginTop: "80px",
              paddingRight: "20%",
              background: `url("/ladder.png") no-repeat right bottom`,
              "@media (min-width: 1024px)": {
                paddingRight: "15%",
              },
              "@media (max-width: 1200px)": {
                fontSize: "70px",
                lineHeight: "70px",
                letterSpacing: "-1.8px",
              },
              "@media (max-width: 1024px)": {
                fontSize: "60px",
                lineHeight: "60px",
                letterSpacing: "-1.8px",
              },
              "@media (max-width: 800px)": {
                fontSize: "60px",
                lineHeight: "60px",
                height: "490px",
                paddingRight: "1%",
                letterSpacing: "-1.8px",
                backgroundSize: "contain",
                backgroundPosition: "center bottom",
              },
              "@media (max-width: 600px)": {
                fontSize: "40px",
                lineHeight: "50px",
                letterSpacing: "-1.8px",
                paddingRight: "1%",
                background: `url("/ladder.png") no-repeat right`,
                backgroundPositionY: "80%",
                backgroundSize: "contain",
              },
              "@media (max-width: 400px)": {
                fontSize: "40px",
                lineHeight: "50px",
                letterSpacing: "-1.8px",
                paddingRight: "1%",
                background: `url("/ladder.png") no-repeat right`,
                backgroundPositionY: "180px",
                backgroundSize: "contain",
              },
            }}
          >
            {isMobile ? (
              <>
                <Box>From bottom-line savings to top-line growth</Box>
              </>
            ) : (
              <>
                <Box>From bottom-line savings</Box>
                <Box>to top-line growth</Box>
              </>
            )}
            <Box
              sx={{
                width: "638px",
                fontSize: isMobile ? "32px " : "40px",
                fontWeight: " 400",
                lineHeight: "50px",
                letterSpacing: "-0.4px",
                marginBottom: "80px",
                fontFamily: "CoFo Sans",
                "@media (min-width: 1024px)": {
                  paddingTop: "10px",
                },
                "@media (max-width: 1024px)": {
                  width: "536px",
                  fontSize: "36px",
                  lineHeight: "40px",
                  paddingTop: "10px",
                },
                "@media (max-width: 800px)": {
                  width: "536px",
                  fontSize: isMobile ? "32px " : "36px",
                  lineHeight: "40px",
                },
                "@media (max-width: 600px)": {
                  width: "80%",
                  fontSize: "24px",
                  lineHeight: "30px",
                  marginBottom: "85px",
                },
                "@media (max-width: 400px)": {
                  width: "80%",
                  fontSize: "24px",
                  lineHeight: "30px",
                  marginBottom: "60px",
                },
              }}
            >
              {isMobile ? (
                <>
                  Maximize procurement
                  <br />
                  value through early involvement
                </>
              ) : (
                <>Maximize procurement value through early involvement</>
              )}
            </Box>

            <StyledButton
              onClick={() => setIsOpenRequestDemo(true)}
              sx={{
                padding: "16px 30px",
                borderRadius: "5px",
                fontWeight: "400",
                fontSize: "18px",
                height: "48px",
                marginBottom: "10px",
                width: isMobile ? "100%" : "fit-content",
                "@media (max-width: 600px)": {
                  marginTop: "120px",
                },
                "@media (max-width: 400px)": {
                  marginTop: "90px",
                },
              }}
              variant={"contained"}
              color={"buttonPrimary"}
              label={"Request demo"}
            />
          </Box>
        </StyledBox>
      </Box>

      <Box
        width={"100%"}
        backgroundColor={"#DADAEF"}
        height={isMobile ? "auto" : "550px"}
      >
        <StyledBox>
          <Stack flexDirection={"column"}>
            <Box>
              <StyledHeader>Value: impacts all metrics</StyledHeader>
            </Box>

            <Stack
              flexDirection={isMobile ? "column" : "row"}
              gap={isMobile ? "20px" : "0"}
              paddingBottom={"20px"}
            >
              {iconTexts.map((text, index) => (
                <Stack
                  padding={"4px"}
                  key={index}
                  width={isMobile ? "90%" : "25%"}
                  flexDirection={isMobile ? "row" : "column"}
                  gap={isMobile ? "20px" : "0"}
                >
                  <Box marginBottom={"16px"}>
                    <img
                      src={`/procurement-icon-${index + 1}.svg`}
                      alt={text}
                    />
                  </Box>
                  <Box width={"80%"}>
                    <Typography
                      sx={{
                        fontSize: "32px",
                        lineHeight: "40px",
                        fontFamily: "CoFo Sans",
                        "@media (max-width: 1024px)": {
                          fontSize: "28px",
                          lineHeight: "34px",
                        },
                        "@media (max-width: 800px)": {
                          fontSize: "28px",
                          lineHeight: "34px",
                        },
                        "@media (max-width: 600px)": {
                          fontSize: "24px",
                          lineHeight: "30px",
                        },
                      }}
                    >
                      {text}
                    </Typography>
                  </Box>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </StyledBox>
      </Box>

      <Stack
        direction={isMobile ? "column" : "row"}
        justifyContent={"space-between"}
        marginBottom={"50px"}
        gap={"40px"}
        sx={{
          "@media (max-width: 600px)": {
            flexWrap: "wrap",
          },
          padding: "73px 10.8% 0 10.8%",
          "@media (max-width: 1240px)": {
            padding: "73px 3% 0 3%",
          },
        }}
      >
        <Stack
          width={isMobile ? "100%" : "50%"}
          sx={{
            "@media (min-width: 1024px)": {
              justifyContent: "center",
            },
          }}
        >
          <Box
            sx={{
              maxWidth: "450px",
              padding: "50px",
              paddingLeft: "0",
              fontSize: isMobile ? "32px " : "40px",
              fontWeight: "400",
              lineHeight: "50px",
              letterSpacing: "-0.4px",
              "@media (max-width: 800px)": {
                width: "100%",
                fontSize: isMobile ? "32px " : "36px",
                lineHeight: "40px",
                padding: "20px",
              },
              "@media (max-width: 600px)": {
                width: "100%",
                fontSize: "32px",
                lineHeight: "40px",
                padding: "5px",
              },
            }}
          >
            Unlock near-real-time visibility into supplier deals company-wide
          </Box>

          {!isMobile && (
            <Box>
              <StyledButton
                onClick={() => setIsOpenRequestDemo(true)}
                sx={{
                  padding: "16px 30px",
                  borderRadius: "5px",
                  fontWeight: "400",
                  fontSize: "18px",
                  height: "48px",
                  marginBottom: "120px",
                  width: isMobile ? "100%" : "fit-content",
                }}
                variant={"contained"}
                color={"buttonPrimary"}
                label={"Request demo"}
              />
            </Box>
          )}
        </Stack>
        <Box
          width={isMobile ? "100%" : "50%"}
          sx={{
            background: `url("/stage-section.png") no-repeat center center`,
            backgroundSize: "contain",
            height: "472px",
            "@media (max-width: 800px)": {
              height: "300px",
            },
            "@media (max-width: 600px)": {
              height: "300px",
            },
          }}
        >
          &nbsp;
        </Box>
        {isMobile && (
          <Box>
            <StyledButton
              onClick={() => setIsOpenRequestDemo(true)}
              sx={{
                padding: "16px 16px",
                borderRadius: "5px",
                fontWeight: "400",
                fontSize: "18px",
                height: "48px",
                marginBottom: "20px",
                width: isMobile ? "100%" : "fit-content",
              }}
              variant={"contained"}
              color={"buttonPrimary"}
              label={"Request demo"}
            />
          </Box>
        )}
      </Stack>

      <RequestDemo
        isOpen={isOpenRequestDemo}
        close={() => setIsOpenRequestDemo(false)}
      />
    </>
  );
}
